import {
  EventTypesScreen,
  FuelAnalysisScreen,
  ReportTemplatesScreen,
  VoyageDetailsScreen,
  VoyageSummaryScreen,
  VoyageTimelineScreen,
} from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeVoyageSource } from '../voyage-source.js';

/**
 * Voyage ▸ Voyage Reports ▸ Voyage Details, Timeline, Summary ve Reference Data ▸ Event Types,
 * Report Templates (ortak ekranlar; ADR 0082 Ek). Ofiste salt okunur: raporlar gemide girilir.
 */
export function VoyageDetailsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.record.details.title')}>
      <VoyageDetailsScreen source={officeVoyageSource} />
    </Shell>
  );
}

export function VoyageTimelinePage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.record.timeline.title')}>
      <VoyageTimelineScreen source={officeVoyageSource} />
    </Shell>
  );
}

export function VoyageSummaryPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.record.summary.title')}>
      <VoyageSummaryScreen source={officeVoyageSource} />
    </Shell>
  );
}

/** Voyage ▸ Performance & Analysis ▸ Fuel & Consumption Analysis (V6; ADR 0090): salt okunur. */
export function FuelAnalysisPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.fuelAnalysis.title')}>
      <FuelAnalysisScreen source={officeVoyageSource} />
    </Shell>
  );
}

export function EventTypesPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.record.eventTypesPage.title')}>
      <EventTypesScreen />
    </Shell>
  );
}

export function ReportTemplatesPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.record.templates.title')}>
      <ReportTemplatesScreen />
    </Shell>
  );
}
